import { createRouter, createWebHashHistory } from "vue-router";
import App from "./App.vue";
import Token from "../src/utilities/jwt/Token"

const routes = [
  {
    path: "/acesso-negado",
    name: "acesso-negado",
    component: () => import("./pages/access/AccessDenied.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("./pages/access/NotFound.vue"),
  },
  {
    path: "/",
    name: "app",
    component: App,
    children: [
      {
        path: "/",
        name: "calendar",
        meta: { isAdm: false },
        component: () => import("./pages/calendar/CalendarView.vue"),
      },
      {
        path: "/eventos",
        meta: { isAdm: true },
        name: "eventos",
        component: () => import("./pages/event/EventView.vue"),
      },
      {
        path: "/responsavel",
        meta: { isAdm: true },
        name: "responsavel",
        component: () => import("./pages/responsible/ResponsibleView.vue"),
      },
      {
        path: "/agendamento",
        meta: { isAdm: false },
        name: "agendamento",
        component: () => import("./pages/register-event/RegisterEvent.vue"),
        children: [
          {
            path: "",
            name: "agendamento-step1",
            meta: { isAdm: false },
            component: () =>
              import("./pages/register-event/components/Step1.vue"),
          },
          {
            path: "/agendamento/evento",
            name: "agendamento-step2",
            meta: { isAdm: false },
            component: () =>
              import("./pages/register-event/components/Step2.vue"),
            beforeEnter: (to, from, next) => {
              if (from.name == "agendamento-step1" || from.name == "agendamento-step3") {
                next()
              } else {
                next("/agendamento")
              }
            },
          },
          {
            path: "/agendamento/calendario",
            name: "agendamento-step3",
            meta: { isAdm: false },
            component: () =>
              import("./pages/register-event/components/Step3.vue"),
            beforeEnter: (to, from, next) => {
              if (from.name == "agendamento-step2") {
                next()
              } else {
                next("/agendamento")
              }
            },
          },
        ],
      },
      {
        path: "/equipamentos",
        name: "equipamentos",
        meta: { isAdm: true },
        component: () => import("./pages/equipament/EquipamentView.vue"),
      },
      {
        path: "/locais",
        name: "locais",
        meta: { isAdm: true },
        component: () => import("./pages/local/LocalView.vue"),
      },
      {
        path: "/log",
        name: "log",
        meta: { isAdm: true },
        component: () => import("./pages/log/LogView.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

//VERIFICA SE POSSUI LOCAL NO SESSION STORAGE, SE NÃO, DEVOLVE PARA A TELA DE NÃO AUTORIZADO
//DESCOMENTAR EM PRODUÇÃO

router.beforeEach((to, from, next) => {
  const local = new Token().getCookie('local');
  const token = new Token().getCookie('access_token');
  if (!token && !local && (to.name !== 'acesso-negado')) {
    next({ name: 'acesso-negado' });
  } else {
    next();
  }
});


export default router;
